import { createSlice } from "@reduxjs/toolkit";
import { transformKeys } from "../../_helper";

const initialState = {
  walletHistoryData: [],
  isLoading: false,
  error: "",
  pagination: {},
};

export const WalletHistorySlice = createSlice({
  name: "WalletHistory",
  initialState,
  reducers: {
    setWalletHistoryData: (state, action) => {
      // Transform all objects in the array
      const transformedData = action.payload.data.data.map(transformKeys);
      const paginator = {
        current_page: action.payload.data.current_page,
        last_page: action.payload.data.last_page,
      };
      state.pagination = paginator;

      state.walletHistoryData = transformedData;
    },
    clearWalletHistoryData: (state) => {
      state.walletHistoryData = [];
    },

    catchError: (state, action) => {
      state.error = action.payload;
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
  },
});

export const {
  setWalletHistoryData,
  clearWalletHistoryData,
  catchError,
  setLoading,
} = WalletHistorySlice.actions;
export default WalletHistorySlice.reducer;
